
  import { Component, Vue, Prop }             from 'vue-property-decorator';
  import { Action }                           from 'vuex-class';
  import { ConfigService,
           ConfigThemeService,
           WidgetConfigEntity }               from '../..';

  @Component({
    name: 'SettingsComponent',
  })
  export default class SettingsComponent extends Vue {
    @Prop() disabledDeleteButton!: boolean;
    @Prop() isFullscreenDisplay!: boolean;
    @Prop() nbMessages!: number;

    @Action('resetNotification', { namespace: 'messages' }) resetNotification: any;
    @Action('getConversationSessionId', { namespace: 'conversationSession' }) getConversationSessionId: any;

    disabledGoToEndOfConversationButton : boolean = true;
    menuOpen: boolean = false;

    /** ******************************************************************** */
    /**                      Get styles                                      */
    /** ******************************************************************** */


    get deleteConversationBtnText() {
      return ConfigService.getDeleteConversationBtnText();
    }

    get goToStartOfConversationBtnText() {
      return ConfigService.getGoToStartOfConversationBtnText();
    }

    get settingsDeleteConversationIcon() {
      return ConfigThemeService.getDeleteConversationIcon();
    }

    get settingsGoToStartOfConversationIcon() {
      return ConfigThemeService.getGoToStartOfConversationIcon();
    }

    get settingsIcon() {
      return ConfigThemeService.getSettingsIcon();
    }

    get deleteConversationColor() {
      return ConfigThemeService.getDeleteConversationColor(this.$vuetify);
    }

    get goToStartOfConversationColor() {
      return ConfigThemeService.getGoToStartOfConversationColor(this.$vuetify);
    }

    get settingsPanelColor() {
      return ConfigThemeService.getSettingsPanelColor(this.$vuetify);
    }

    get settingsIconColor() {
      return ConfigThemeService.getSettingsIconColor(this.$vuetify);
    }

    get settingsMenuLeft() {
      if(this.isFullscreenDisplay){
        return ConfigThemeService.getSettingsMenuLeft();
      }
      return 0;
    }

    get settingsMenuTop() {
      return ConfigThemeService.getSettingsMenuTop();
    }

    get mainButtonTabindex() {
      return this.menuOpen ? -1 : 3;
    }

    /** ********************************************************************* */
    /**                           TITTLE FOR BUTTONS                          */
    /** ********************************************************************* */

    get settingsButtonTitle() {
      return ConfigService.getSettingsButtonTitle();
    }

    /** ******************************************************************** */
    /**                      Utility functions                               */
    /** ******************************************************************** */

    refreshSession() {
      this.resetNotification()
      this.disabledDeleteButton = false;

      // Retrieve conversation session 
      const widgetConfig: WidgetConfigEntity | undefined = ConfigService.widgetConfig;
      if (widgetConfig) {
        let isRefresh = true
        this.getConversationSessionId({ widgetConfig , isRefresh}); 
      }
      this.$vuetify.theme.dark = (ConfigThemeService.getDefaultTheme() === 'dark');
    }

    goToStartOfConversation() {
      const messagesContainer = document.getElementById('chatbox-msg-list');
      if (messagesContainer) {
        messagesContainer.scrollTop = 0;
      }
    }

    checkScroll() {
      const messagesContainer = document.getElementById('chatbox-msg-list');
      if (messagesContainer) {
        this.disabledGoToEndOfConversationButton = messagesContainer.scrollTop === 0 || messagesContainer.scrollHeight === messagesContainer.clientHeight;
        this.menuOpen = false;
      }
    }

    mounted() {
      this.checkScroll();
      window.addEventListener('resize', this.checkScroll);
      const messagesContainer = document.getElementById('chatbox-msg-list');
      if (messagesContainer) {
        messagesContainer.addEventListener('scroll', this.checkScroll);
      }
    }
}
